import request from '@/utils/request';

/**
 * 系统配置
 * @returns {{getAgreementList: (function(*): *), getAgreementsInfo: (function(*): *), edit: (function(*=): *), del: (function(*=): *)}}
 */
export function systemEtcApi () {
    return {

        //配置详情
        getSystemEtcInfo: params => {
            return request ({
                url: '/admin/system_config/system_etc/info',
                method: 'get',
                params,
            });
        },

        //编辑配置
        editSystemEtcInfo: params => {
            return request ({
                url: '/admin/system_config/system_etc/edit',
                method: 'post',
                params,
            });
        },

    };
}
